'use client';
import React, { useState, useEffect } from 'react';
import { shouldShowSignUp } from '@/lib/utils';
import Balancer from 'react-wrap-balancer';
import { Link } from 'react-router-dom';
import { Button } from './button';
import { useTranslation } from 'react-i18next';

export const CTA = () => {
  const { t } = useTranslation('common');
  const showSignUp = shouldShowSignUp();

  return (
    <section className="w-full overflow-hidden relative z-30 pt-20 pb-20 ">
      <div className=" dark:bg-transparent">
        <div className="mx-auto w-full relative z-20 sm:max-w-[40rem] md:max-w-[48rem] lg:max-w-[64rem] xl:max-w-[80rem] bg-gradient-to-br from-slate-800/90 dark:from-neutral-900/90 to-gray-900/90 backdrop-blur-sm sm:rounded-2xl">
          <div className="relative -mx-6 sm:mx-0 sm:rounded-2xl overflow-hidden px-6 md:px-8">
            <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-blue-500/10 to-purple-500/10"></div>
            <div
              className="pointer-events-none absolute inset-y-0 right-0 select-none overflow-hidden rounded-2xl"
              style={{
                mask: 'radial-gradient(33.875rem 33.875rem at calc(100% - 8.9375rem) 0, white 3%, transparent 70%)',
              }}
            ></div>

            <div className="relative px-6 pb-14 pt-20 sm:px-10 sm:pb-20 lg:px-[4.5rem]">
              <h2 className="text-center text-balance mx-auto text-3xl md:text-5xl font-semibold tracking-[-0.015em] text-white">
                {t('cta.title')}
              </h2>
              <p className="mt-4 max-w-[36rem] text-center mx-auto text-base/6 text-neutral-200">
                <Balancer>{t('cta.description')}</Balancer>
              </p>

              <div className="relative z-10 mx-auto flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <Link to="/book-demo">
                  <Button className="px-6 py-2.5 text-base shadow-lg hover:scale-105 transition-all duration-200 w-full sm:w-auto">
                    {t('cta.bookDemo')}
                  </Button>
                </Link>
                {showSignUp && (
                  <Link to="/signup">
                    <Button className="px-6 py-2.5 text-base bg-transparent border-2 border-white/20 hover:border-white/40 shadow-lg hover:scale-105 transition-all duration-200 w-full sm:w-auto">
                      {t('cta.signUp')}
                    </Button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
